export function localeReverser(locale: string | undefined) {
  if (!locale || locale.includes("_")) return locale;
  const localeParts = locale.split("/");
  if (localeParts.length === 2) {
    return `${localeParts[1]}_${localeParts[0]}`;
  }
  return locale;
}
